import { render, staticRenderFns } from "./MenuPerimetro.vue?vue&type=template&id=21149fb2&scoped=true"
import script from "./MenuPerimetro.vue?vue&type=script&lang=js"
export * from "./MenuPerimetro.vue?vue&type=script&lang=js"
import style0 from "./MenuPerimetro.vue?vue&type=style&index=0&id=21149fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21149fb2",
  null
  
)

export default component.exports